// 图都用的cdn, 传图的地方在【模板中心 - 工具 - S3】http://tpl.tbox.me/dashboard
export const AssetImageUrl = {
  "ic_back@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/5cf6979441aa443097aa2e45a7376a3d5fc85e9b74043_ic_back%403x.png",
  "ic_closed@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/e0f296004c154b468efe6dc9bfd668075fc85e9b78422_ic_closed%403x.png",
  "ic_Help Center1@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/76e1c751148a4fb79d0553fecafebe685fc85e9b74c79_ic_help%20center1%403x.png",
  "ic_menu@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/592b12bad4f8411b99edb1987df871ff5fc85e9b7b4ad_ic_menu%403x.png",
  "ic_My Account1@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/82c6260a26274f0dba4ca2d92d3230b25fc85e9b77dc2_ic_my%20account1%403x.png",
  "ic_My Favorites@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/35089d19af5b40459d51c4a103da82d95fc85e9b77894_ic_my%20favorites%403x.png",
  "ic_My Orders@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/de93eaa5740e4fd78022044765dd11b55fc85e9bd0a71_ic_my%20orders%403x.png",
  "ic_next@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/a0f2c30d848442e89717c5e2779c56835fc85e9bd41a1_ic_next%403x.png",
  "ic_search@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/fa8f4469d31147019cf8faede22def135fc85e9bd4bc5_ic_search%403x.png",
  "tabbar_ic_account@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/ce64b7874f1b4f35b20b133216d090735fc87aebe008f_tabbar_ic_account%403x.png",
  "tabbar_ic_cart@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/812864cd456d4977bde36b632a3fc1ba5fc87aebe002a_tabbar_ic_cart%403x.png",
  "tabbar_ic_center@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/399a1d7104f74bedb329d67054a102ef5fc87aebe267b_tabbar_ic_center%403x.png",
  "tabbar_ic_home@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/649df70200144a37aaae3fddd449a8735fc87aec17a90_tabbar_ic_home%403x.png",
  "ic_箭头@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/6acb1b617e7342e8bdf8fb613984682f5fc8801390d78_ic_%E7%AE%AD%E5%A4%B4%403x.png",
  "ic_closed2@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/916f3dba6ca74aec897a435f138435515fc8801390ced_ic_closed2%403x.png",
  "ic_deleted@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/759c52c7d3204fd0a8c147e11b2624055fc88013e6fc1_ic_deleted%403x.png",
  "ic_right@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/d7d46dd7f2894736a4c0975ea0c77f705fc88013e4b51_ic_right%403x.png",
  "ic_clear@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/4a3de14981524a5a808d7146638df13f5fc8801418fda_ic_clear%403x.png",
  "ic_time@3x.png":
    "https://litb-cgis.rightinthebox.com/imagegy/202101/c5f0ce9615e3433f80de89eaf77e12015fd19110f0757_ic_time%403x.png",
  "logo@3x.png":
    "https://lijc.rightinthebox.com/jupiter_lightsource/img/temp/site/ouku/logo_icon-7d1bea1440.png",
  "ic_download@3x.png":
    "https://lijc.rightinthebox.com/jupiter_lightsource/img/ouku_download_icon.png",
  "bg@3x.png":
    "https://lijc.rightinthebox.com/jupiter_lightsource/img/temp/site/ouku/app_download_bg-6a14f6c815.png",
  // PC 专属
  pc_flag:
    "https://lijc.rightinthebox.com/resource_0371e793fd1099cee491071190a2714be9864f53_ouku//dev_v2/base-images/flag.png",
  pc_arrow:
    "https://litb-cgis.rightinthebox.com/imagegy/202101/951f70e9c86e4c33aaec5bc586a925fcen_1.png",
};
